module.exports = __webpack_public_path__ + "be5192eca79585a55b2f00158e6ff046.woff2";